import React, {useContext} from 'react';
import Button from "../../UI/Button";
import Input from "../../UI/Input";
import MyCustomChartBalance from "./MyCustomChartBalance";
import {PdfBootstrapIcon} from "../../../Assets/svg";
import {formatToPersianAddComma} from "../../../utils/CommaSeparator";
import {useDispatch, useSelector} from "react-redux";
import {CalculateInformationUnderTable, downloadFileHandler} from "./functions";
import {useHotkeys} from "react-hotkeys-hook";
import utilsFunction from "../../../utils/utilsFunction";
import {toast} from "react-toastify";
import {submitDocumentFormAction} from "../../Store/SubmitDocumentForm";
import {SetPrintDataContext} from "../../../Pages";
import {useNavigate} from "react-router-dom";

const ControlUnderTable = () => {


  const sendData = useSelector(s => s.submitDocumentFormReducer)
  const dispatch = useDispatch();
  const setprint = useContext(SetPrintDataContext);
  let navigate = useNavigate();

  useHotkeys("ctrl+p", (e) => {
    e.preventDefault();
    // looks like there is a bug! whern user press control this function fire
    // so i  check e.key and Then run Main Function

    //e.key !== 'Control' && onPrintHandler()

  });


  useHotkeys("ctrl+s", (e) => {
    // e.preventDefault();
    //downloadFileHandler();
  });

  // const myRef = useRef()
  // const clickOnPrintRef = useRef()

  const handleFileRead = (e) => {
    const content = e.target.result;
    // setText(content);
    console.log(content);
    //
    const uploadedTableData = utilsFunction.makeReadyToTableConfigFromUpload(
      content + ""
    );

    const result = CalculateInformationUnderTable(uploadedTableData);
    // setInfoUnderTable(result);
    //const tempChartDataUnderTable = drawNew(result);

    // setChartDataUnderTable(tempChartDataUnderTable);

    dispatch(submitDocumentFormAction.fillInput({tableData: uploadedTableData}));

    toast.info("فایل بارگزاری شد.");
    //
  };

  const handleFileChosen = (file) => {
    const reader = new FileReader();
    reader.onloadend = handleFileRead;
    reader.readAsText(file);
  }

  function uploadFileHandler(e) {
    handleFileChosen(e.target.files[0]);
  }

  const onPrintHandlerHere = () => {

    const sendPrintData = {
      type: "ControlUnderTablePrint",
      data: sendData,
      title:"سند حسابداری"
    };
    setprint(sendPrintData);
    navigate("/factorprint");
    console.log(sendData)
  }
  return (
    <>
      <div className={"w-100 d-flex justify-content-start   align-items-center "}
        // style={{background:'#d5d5ff',}}
      >

        <div>
          <label


            htmlFor={"upload"}
            className={"d-block mt-2 d-flex justify-content-center align-items-center white__button__hover__blue text-nowrap"}>
            بارگزاری فایل
            {/*<label htmlFor={"upload"} style={{*/}
            {/*  background: "#fff",*/}
            {/*  width: "100%",*/}
            {/*  height: "45px",*/}
            {/*  borderRadius: 10,*/}
            {/*  position: "relative",*/}
            {/*  cursor: "pointer"*/}
            {/*}}*/}
            {/*       onDragOver={e => {*/}
            {/*         e.preventDefault();*/}
            {/*         e.target.style.cursor = 'cell';*/}
            {/*       }}*/}
            {/*  onDrop={e => {*/}
            {/*    e.preventDefault()*/}
            {/*    let file = e.dataTransfer.files[0]*/}
            {/*    props.onUpload(file)*/}
            {/*  }}*/}
            {/*>*/}

            {/*<div style={{*/}
            {/*  top: '50%',*/}
            {/*  left: '50%',*/}
            {/*  transform: 'translate(-50%, -50%)',*/}
            {/*  color: '#a0a0a0'*/}
            {/*}} className={"position-absolute"}>*/}
            {/*  رها کن*/}
            {/*</div>*/}
            <Input type={"file"}
                   className={"d-none width__345 my-2 w-100  w-100 bg__white"}
                   id={"upload"}
                   onChange={(e) => {
                     uploadFileHandler(e);
                     e.target.value = null
                   }}
            />
          </label>
        </div>


        <Button onClick={() => downloadFileHandler(sendData.tableData)} className={"white__button__hover__blue text-nowrap"}> ذخیره
          در فایل</Button>
        <Button onClick={onPrintHandlerHere} className={" white__button__hover__blue text-nowrap"}>
          پرینت
          <PdfBootstrapIcon/>

        </Button>
        <div className={"text-center mx-4"}>
          <div className={"text-nowrap"}>مانده تراز شدن</div>
          <div>{formatToPersianAddComma(sendData.remainToBalance)}</div>
        </div>
        <div className={" text-center mx-4"}>
          <div>
            <div className={"text-nowrap"}>جمع بدهکار</div>
            <div>{formatToPersianAddComma(sendData.sumOfBed)}</div>
          </div>
        </div>
        <div className={"text-center mx-4"}>
          <div
            className={"text-nowrap"}>جمع بستانکار
          </div>
          <div>{formatToPersianAddComma(sendData.sumOfBes)}</div>
        </div>
        <div
          className={"w-100"}
        >
          <MyCustomChartBalance/>
        </div>


      </div>
    </>
  );
};

export default ControlUnderTable;
